import React from 'react'
import { Collection } from '@morningtrain/react-resources'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import { Card, Table } from 'ui'
import * as Columns from 'support/columns'
import TranslatedTitle from 'widgets/TranslatedTitle'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import { MountSmartview, MountSmartviewOnClick } from '@morningtrain/react-smartviews'
import CreateOrUpdateVacationRequestSmartview
  from 'widgets/smartviews/vacation-requests/CreateOrUpdateVacationRequestSmartview'
import MountSmartviewOnClickTableRow from 'widgets/crud/MountSmartviewOnClickTableRow'
import { Period } from 'support/displays'
import { PaginationFilter } from '@morningtrain/react-filters'

export default function MyRequests () {
  return (
    <AdminPageWithSmartview>
      <MountSmartview smartview={<CreateOrUpdateVacationRequestSmartview create={true}/>}/>
      <Translator namespace='vacation.my_requests'>

        <Collection resourceName='vacation.vacation_requests' operationName='my_requests'>

          <UI.PageHeader title={<TranslatedTitle name='header'/>}>
            <UI.ButtonWrap>
              <MountSmartviewOnClick smartview={<CreateOrUpdateVacationRequestSmartview create={true}/>}>
                <UI.Button>
                  <Translation name={'new_request'}/>
                </UI.Button>
              </MountSmartviewOnClick>
            </UI.ButtonWrap>
          </UI.PageHeader>

          <Card>
            <Table row={<MountSmartviewOnClickTableRow smartview={<CreateOrUpdateVacationRequestSmartview/>}/>}>
              <Translator namespace="vacation.my_requests.columns">
                <Columns.DateTime name="created_at"/>
                <Columns.Column display={<Period fromName="requested_start_at" toName="requested_end_at"/>}
                                label={<Translation name="period_requested"/>}/>
                <Columns.Column display={<Period fromName="start_at" toName="end_at"/>}
                                label={<Translation name="period_approved"/>}/>
                <Columns.Enum enum="request_status" name="status"/>
                <Columns.Text name="responder.name" label={<Translation name="responder_name"/>}/>
                <Columns.DateTime name="responded_at"/>
              </Translator>
            </Table>
            <PaginationFilter/>
          </Card>
        </Collection>

      </Translator>
    </AdminPageWithSmartview>
  )
}
